<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column pr-0">
        <div class="card flex-1-auto h-100 overflow-auto">
            <div class="card-header card-header-with-button">
               <h5>{{$t('JOBRECURRING')}}</h5>
               <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
            </div>
            <div class="card-body" v-if="globals && globals.groupId != 8">
              <div class="row">
                <div class="col-12">
                  <div class="flex-0-auto mb-3">
                    <div class="buttons-group">
                      <label class="has-float-label mr-2" v-if="globals.groupId === 1 || globals.globals === 5">
                          <b-form-fieldset v-bind:label="$t('USERCOMPANIES')">
                              <lbselect 
                                :empty="true" 
                                :list="companyData.root" 
                                :total-count="companyData.totalCount"
                                :pagination="paginationCompany"
                                v-on:reload="getCompanyData()"
                                v-model="paginationSec.companyId" 
                                value-field="companyId" 
                                display-field="companyName">
                              </lbselect>
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2" v-if="(globals && globals.acl && globals.acl.BuildingDetail && globals.acl.BuildingDetail.insertAction)">
                          <b-form-fieldset v-bind:label="$t('CLIENT')">
                              <lbselect 
                                :empty="true" 
                                :list="building.root" 
                                :total-count="building.totalCount"
                                :pagination="paginationBuilding"
                                v-on:reload="getBuildingData()"
                                v-model="paginationSec.client" 
                                value-field="buildingDetailId" 
                                display-field="clientName">
                              </lbselect>
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('ADDRESS')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.address">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <span>{{$t('COMPANYWORKER')}}</span>
                              <input class="form-control" placeholder=" " v-model="paginationSec.companyWorker">
                          </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                        <b-form-fieldset v-bind:label="$t('DATE')">
                            <datetimepicker
                                type="date"
                                v-model="paginationSec.date"
                                format="YYYY-MM-DD"
                                display-format="DD.MM.YYYY."
                                placeholder=" "
                                :isClearable="true"
                                :showSeconds="false"
                                :isUTC="false"
                                :simple="true"
                                class="form-control"
                                :translate-method="trans">
                            </datetimepicker>
                        </b-form-fieldset>
                      </label>
                      <label class="has-float-label mr-2">
                          <b-form-fieldset>
                              <button type="button" class="btn-bis btn-tertiary mtt-2" @click="getData()"><!--icon icon="search"></icon-->{{$t('SEARCH')}}</button>
                          </b-form-fieldset>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('CLIENT')}}</th>
                    <th>{{$t('USERSUBCOMPANIES')}}</th>
                    <th>{{$t('FLOW')}}</th>
                    <th>{{$t('RECURRINGTYPE')}}</th>
                    <th>{{$t('INTERVAL')}}</th>
                    <th>{{$t('ISACTIVE')}}</th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="item in data.root" :key="item.jobReccuringId" aria-rowindex="1" class=" table-ellipsis">
                        <td>{{item.jobReccuringId}}</td>
                        <td>{{item.client}}</td>
                        <td>{{item.subCompanyName}}</td>
                        <td>{{item.flow}}</td>
                        <td>{{item.recurringType}}</td>
                        <td>{{item.interval}}</td>
                        <td>{{(item.isActive) ? $t('YES') : $t('NO')}}</td>
                        <td class="table-buttons">
                          <b-button type="reset" class="btn-table table-btn-tertiary"  @click="showModal(item)">{{$t('EDIT')}}</b-button>
                          <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.jobReccuringId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <jobform v-model="formData" v-on:close="formData = null; getData()"></jobform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/job_recurring/JobRecurring.js';
import BuildingApi from '@/api/building_detail/BuildingDetail.js';
import CompanyApi from '@/api/admin/UserCompanies'
import JobForm from './Form.vue';
import localTranslate from '../../helpers/local_trans';


export default {
    name: 'Job',
    components:
    {
        jobform: JobForm,
    },
    data()
    {
        const me = this;

        return {
            loading: true,
            data: {},
            companyData: {},
            building: {},
            formData: null,
            formAnswers: null,
            formViewAnswers: null,
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationSec: {
                companyId: null,
                client: null,
                address: null,
                companyWorker: null,
                date: null,
                status: null,
            },
            paginationBuilding: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            paginationCompany: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
    {
        trans(key)
        {
            const me = this;
            return localTranslate(me.globals.langId, key);
        },
      async getCompanyData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await CompanyApi.selectRow(me.getParamsCompany);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.companyData = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async getBuildingData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await BuildingApi.selectRow(me.getParamsBuilding);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.building = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (typeof item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination, ...me.paginationSec };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsBuilding()
      {
          const me = this;
          const data = { ...me.paginationBuilding };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
      getParamsCompany()
      {
          const me = this;
          const data = { ...me.paginationCompany };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
